var map = {
	"./icon-setting.svg": "6a4f",
	"./icon_add files.svg": "9e8d",
	"./icon_add friend.svg": "b5b7",
	"./icon_add.svg": "c49e",
	"./icon_address.svg": "e506",
	"./icon_adjust.svg": "b24e",
	"./icon_after sales.svg": "0aed",
	"./icon_alarm.svg": "d2f7",
	"./icon_alert.svg": "8d03",
	"./icon_all day.svg": "287e",
	"./icon_arrow_left.svg": "26c6",
	"./icon_arrow_right.svg": "4f0b",
	"./icon_asset.svg": "af55",
	"./icon_attention.svg": "a2b4",
	"./icon_aviation.svg": "89aa",
	"./icon_back.svg": "3eaf",
	"./icon_bluetooth.svg": "82d8",
	"./icon_browser.svg": "8cb5",
	"./icon_buy.svg": "feee",
	"./icon_calculator.svg": "f588",
	"./icon_camera.svg": "e725",
	"./icon_caret.svg": "05c2",
	"./icon_caret_left.svg": "1199",
	"./icon_caret_right.svg": "c790",
	"./icon_cart.svg": "b6f0",
	"./icon_cellphone.svg": "79ff",
	"./icon_choice.svg": "e9ed",
	"./icon_clean.svg": "1ab1",
	"./icon_click.svg": "f490",
	"./icon_cloud-based.svg": "c96e",
	"./icon_collect.svg": "2051",
	"./icon_color.svg": "d8f7",
	"./icon_comment.svg": "db8f",
	"./icon_company.svg": "00d2",
	"./icon_computer.svg": "94a3",
	"./icon_contact list.svg": "237c",
	"./icon_cooperation.svg": "7a46",
	"./icon_copy.svg": "84a8",
	"./icon_coupons.svg": "9426",
	"./icon_crown.svg": "a583",
	"./icon_customer service.svg": "cba1",
	"./icon_data.svg": "8ae3",
	"./icon_date.svg": "54ba",
	"./icon_delete.svg": "f1f2",
	"./icon_diamond.svg": "aad9",
	"./icon_download.svg": "6139",
	"./icon_dress up.svg": "1c95",
	"./icon_edit.svg": "fdc3",
	"./icon_education.svg": "1871",
	"./icon_employ.svg": "8cf1",
	"./icon_enclosure.svg": "a773",
	"./icon_examine.svg": "6d5e",
	"./icon_excel.svg": "063a",
	"./icon_express.svg": "b02e",
	"./icon_female.svg": "0c8b",
	"./icon_file.svg": "b2fb",
	"./icon_find.svg": "5e38",
	"./icon_footprint.svg": "4601",
	"./icon_forward.svg": "8beb",
	"./icon_friends.svg": "31a3",
	"./icon_full screen.svg": "2141",
	"./icon_gesture.svg": "331d",
	"./icon_gift.svg": "d906",
	"./icon_global.svg": "871d",
	"./icon_grid.svg": "da6e",
	"./icon_help.svg": "70c6",
	"./icon_home.svg": "d820",
	"./icon_hot.svg": "25ab",
	"./icon_idea.svg": "18a5",
	"./icon_information.svg": "6063",
	"./icon_input.svg": "5efd",
	"./icon_integral.svg": "6ffa",
	"./icon_invisible.svg": "c721",
	"./icon_invitation.svg": "4064",
	"./icon_invoice.svg": "900c",
	"./icon_label.svg": "7dc1",
	"./icon_layout.svg": "2025",
	"./icon_lightning.svg": "26c5",
	"./icon_like.svg": "e0fe",
	"./icon_link.svg": "d5fc",
	"./icon_list.svg": "c7b4",
	"./icon_location.svg": "5501",
	"./icon_mail.svg": "ed2c",
	"./icon_male.svg": "4fa2",
	"./icon_map.svg": "e59d",
	"./icon_me.svg": "30dc",
	"./icon_medal.svg": "8c05",
	"./icon_menu.svg": "1686",
	"./icon_microphone.svg": "3da8",
	"./icon_minus.svg": "b0c0",
	"./icon_minus_circle.svg": "972a",
	"./icon_more.svg": "6a53",
	"./icon_mouse.svg": "e776",
	"./icon_move up.svg": "cc15",
	"./icon_move.svg": "1210",
	"./icon_music.svg": "d095",
	"./icon_news.svg": "566d",
	"./icon_next.svg": "b7a8",
	"./icon_notice.svg": "dec3",
	"./icon_order.svg": "6874",
	"./icon_password.svg": "96b5",
	"./icon_pause.svg": "77ed",
	"./icon_personal center.svg": "90e0",
	"./icon_personal information.svg": "8bdd",
	"./icon_phone.svg": "b80f",
	"./icon_photo.svg": "dbee",
	"./icon_pie chart.svg": "0c47",
	"./icon_play.svg": "491d",
	"./icon_plus.svg": "4625",
	"./icon_plus_circle.svg": "c1c5",
	"./icon_ppt.svg": "856c",
	"./icon_praise.svg": "0ac1",
	"./icon_prepaid card.svg": "d800",
	"./icon_previous.svg": "90cc",
	"./icon_printer.svg": "f5fe",
	"./icon_qr code.svg": "e113",
	"./icon_read.svg": "8f0a",
	"./icon_red packet.svg": "6565",
	"./icon_refresh.svg": "abbd",
	"./icon_remove friend.svg": "acc5",
	"./icon_resources.svg": "e878",
	"./icon_rest.svg": "5c45",
	"./icon_resume.svg": "831e",
	"./icon_revise.svg": "81ef",
	"./icon_right.svg": "15e3",
	"./icon_right_circle.svg": "ab25",
	"./icon_route.svg": "17c2",
	"./icon_save.svg": "2655",
	"./icon_scan.svg": "c2b2",
	"./icon_screen.svg": "06aa",
	"./icon_search.svg": "317e",
	"./icon_security.svg": "c311",
	"./icon_server.svg": "3e34",
	"./icon_set top.svg": "ee90",
	"./icon_setting.svg": "bbf2",
	"./icon_share.svg": "87c3",
	"./icon_sign in.svg": "8c58",
	"./icon_sign out.svg": "7955",
	"./icon_sign.svg": "5ec8",
	"./icon_signal.svg": "45b6",
	"./icon_small screen.svg": "b8b0",
	"./icon_switch.svg": "c947",
	"./icon_target.svg": "8f1e",
	"./icon_text.svg": "6ec9",
	"./icon_three-dimensional.svg": "0af3",
	"./icon_time.svg": "1c75",
	"./icon_train.svg": "901a",
	"./icon_transport.svg": "2af4",
	"./icon_travel.svg": "4537",
	"./icon_trophy.svg": "99c6",
	"./icon_upload.svg": "f47d4",
	"./icon_verification code.svg": "bf24",
	"./icon_video camera.svg": "419a",
	"./icon_view.svg": "e1f2",
	"./icon_visible.svg": "4523",
	"./icon_voice.svg": "880c",
	"./icon_wallet.svg": "c65e",
	"./icon_warning.svg": "400f",
	"./icon_weather.svg": "a6c9",
	"./icon_wifi.svg": "2848",
	"./icon_word size_enlarge.svg": "5bd8",
	"./icon_word size_narrow.svg": "2a13",
	"./icon_word.svg": "8263",
	"./icon_wrong.svg": "0447",
	"./icon_wrong_circle.svg": "6ad2",
	"./icon_zoom_in.svg": "ec26",
	"./icon_zoom_out.svg": "800e",
	"./password.svg": "2a3d",
	"./user.svg": "b3b5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";